import { Flex, Button, Box } from '@chakra-ui/react';
import { decode } from 'js-base64';
import { useMemo, useCallback } from 'react';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { KText } from '@/ui-library/components';
import ZoomLogo from '@/assets/icons/conference/Zoom';

const ReconnectZoomContent = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;

  const { url } = useMemo(() => {
    try {
      if (!custom_attributes) return {};
      return JSON.parse(decode(custom_attributes));
    } catch (err) {
      console.error('Error decoding reconnect zoom notification', err);
      return {};
    }
  }, [custom_attributes]);

  const handleReauthenticate = useCallback(() => {
    if (url) {
      window.open(url, '_self');
      onClose();
    }
  }, [url, onClose]);

  return (
    <Flex alignItems="start" gap="14px">
      <Box
        px="12px"
        pt="8px"
        pb="10px"
        borderRadius="8px"
        bg="pastel-1-light"
        flexShrink={0}
      >
        <ZoomLogo width="16" height="16" />
      </Box>
      <Flex flexDir="column" gap="8px" alignSelf="start" flex="1">
        <KText>
          Your Zoom integration has expired. Reauthenticate to continue
          scheduling interviews on Zoom.
        </KText>
        <NotificationTime notification={notification} />
        <Button
          variant="primary"
          size="sm"
          w="fit-content"
          onClick={handleReauthenticate}
          data-test-id="reauthenticate-zoom-button"
        >
          Reauthenticate
        </Button>
      </Flex>
    </Flex>
  );
};

export const ReconnectZoomNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ReconnectZoomContent notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
